import React, { useState, useEffect } from "react";

const CustomeToggleButton = ({ initialChecked = false, onChange }) => {
  const [isToggled, setIsToggled] = useState(initialChecked);

  // Effect to sync internal state with initialChecked prop
  useEffect(() => {
    setIsToggled(initialChecked);
  }, [initialChecked]);

  const handleToggle = () => {
    const newState = !isToggled;
    setIsToggled(newState);
    if (onChange) onChange(newState); // Call the onChange prop if provided
  };

  return (
    <div className="flex items-center">
      <div
        onClick={handleToggle}
        className={`relative w-10 h-5 flex items-center rounded-full  cursor-pointer transition-colors duration-300 ${
          isToggled ? "bg-[var(--color--2)]" : "bg-gray-300 "
        }`}
      >
        <div
          className={`absolute w-5 h-5 bg-gray-500 rounded-full shadow-md transform transition-transform duration-300 ${
            isToggled ? "translate-x-full" : "translate-x-0"
          }`}
        />
      </div>
    </div>
  );
};

export default CustomeToggleButton;
